export enum RemindMeEnum {
  OneDay = '1',
  FifteenDays = '15',
  ThirtyDays = '30'
}
